var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable no-empty-pattern */
import { Button, DialogActions, DialogContent, DialogTitle, Paper } from '@material-ui/core';
import React from 'react';
import Draggable from 'react-draggable';
import { IndependentDialog, Wrapper } from './DraggableDialog.Styles';
var PaperComponent = function (props) {
    return (React.createElement(Draggable, { handle: "#draggable-dialog-title", cancel: '[class*="MuiDialogContent-root"]' },
        React.createElement(Paper, __assign({}, props))));
};
export var DraggableDialog = function (_a) {
    var open = _a.open, title = _a.title, onClose = _a.onClose, hideBackdrop = _a.hideBackdrop, actions = _a.actions, scroll = _a.scroll, children = _a.children, disableBackdropClick = _a.disableBackdropClick;
    return React.createElement(Wrapper, null,
        React.createElement(IndependentDialog, { scroll: scroll, open: open, onClose: onClose, PaperComponent: PaperComponent, "aria-labelledby": "draggable-dialog-title", hideBackdrop: hideBackdrop, disableBackdropClick: disableBackdropClick },
            React.createElement(DialogTitle, { style: { cursor: 'move' }, id: "draggable-dialog-title" }, title),
            React.createElement(DialogContent, null, children),
            (actions === null || actions === void 0 ? void 0 : actions.length) && React.createElement(DialogActions, null, actions.map(function (action) { return React.createElement(Button, { autoFocus: true, onClick: function () { return action.onClick(); }, color: "primary" }, action.title); }))));
};
DraggableDialog.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=DraggableDialog.js.map